import { SelectedWorkspaceCtx } from "../contexts/SelectedWorkspaceCtx";

export interface WorkspaceType {
  id: number;
  unique_workspace_id: string;
  name: string;
  description: string | null;
  logo_url: null | string;
  website_url: null | string;
  domain: null | string;
};

type WorkspaceSubscriberArgs = {
  workspaces: WorkspaceType[];
  isLoading: boolean;
  firstFetch: boolean;
};

type WorkspaceSubscriber = (args: WorkspaceSubscriberArgs) => void;

export const workspaceStore = {
  workspaces: [] as WorkspaceType[],
  loading: false,
  firstFetch: false,

  subscribers: [] as WorkspaceSubscriber[],

  // Add a subscriber
  subscribe(callback: WorkspaceSubscriber) {
    this.subscribers.push(callback);
    // Return an unsubscribe function
    return () => {
      this.unsubscribe(callback);
    };
  },

  // Remove a subscriber
  unsubscribe(callback: WorkspaceSubscriber) {
    this.subscribers = this.subscribers.filter(sub => sub !== callback);
  },

  // Notify all subscribers
  notifySubscribers() {
    const args: WorkspaceSubscriberArgs = {
      workspaces: this.workspaces,
      isLoading: this.loading,
      firstFetch: this.firstFetch,
    };
    this.subscribers.forEach(callback => callback(args));
  },

  setWorkspaces(newWorkspaces: WorkspaceType[]) {
    this.workspaces = newWorkspaces;
    SelectedWorkspaceCtx.loadSelectedWorkspace(this.workspaces);
    this.loading = false;
    if (this.firstFetch === false) this.firstFetch = true;
    this.notifySubscribers();
  },

  setLoading(isLoading: boolean) {
    this.loading = isLoading;
    this.notifySubscribers();
  },

  clearAllWorkspaces() {
    this.workspaces = [];
    this.loading = false;
    this.firstFetch = false;
  }
};